import format from 'string-format'
import {obj_to_FormData} from "./utils";
import session from './session'

export default {

	/*
	/**/
	data_sync(experiment, params) {
		// let data = obj_to_FormData(params)

		// return session.request({
		// 	method: 'POST',
		// 	url: format('/ngs_exp/{pk}/data_sync/', {pk: experiment.id}),
		// 	headers: {'Content-Type': 'multipart/form-data',},
		// 	data
		// })
		return session.post(
			format('/ngs_exp/{pk}/data_sync/', {pk: experiment.id}),
			params
		)
	}
}